<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
            <form #form="ngForm" name="form" novalidate (ngSubmit)="atualizar()">
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                    </div>
                </div>
                <div class="formgroup" *ngIf="itemProduto && !exibirSpinnerPrincipal">
                    <p-tabView styleClass="tabview-custom" (onChange)="onTabChange($event)">
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <i class="pi pi-calendar mr-1"></i>
                                <span>Cadastro</span>
                            </ng-template>
                            <div class="p-fluid p-formgrid grid">
                                <div class="field col-12 md:col-12"></div>
                                <div class="field col-12 md:col-5">
                                    <label htmlFor="descricao">Descrição</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        type="text"
                                        pInputText
                                        placeholder="Descrição do produto"
                                        name="descricao"
                                        [(ngModel)]="itemProduto.descricao"
                                        ngModel
                                        #descricao="ngModel"
                                        required
                                    />
                                    <div
                                        *ngIf="descricao.hasError('required') && descricao.touched"
                                        class="alerta"
                                    >
                                        <span>Campo obrigatório!</span>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="fabricante">Fabricante</label>
                                    <p-dropdown
                                        [options]="fabricantes"
                                        optionLabel="descricao"
                                        [filter]="true"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="fabricante"
                                        ngModel
                                        #fabricante="ngModel"
                                        [(ngModel)]="itemProduto.fabricante"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label htmlFor="subgrupo">Grupo</label>
                                    <p-dropdown
                                        [options]="grupos"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        [(ngModel)]="itemProduto.subgrupo"
                                        emptyFilterMessage="Nenhum registro"
                                        name="subgrupo"
                                        ngModel
                                        #subgrupo="ngModel"
                                    ></p-dropdown>
                                    <div
                                        *ngIf="subgrupo.touched && !subgrupoSelecionado"
                                        class="alerta"
                                    >
                                        <span>Por favor, selecione um valor.</span>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="valorCompra">Valor Compra</label>
                                    <p-inputNumber
                                        name="valorCompra"
                                        ngModel
                                        #valorCompra="ngModel"
                                        [(ngModel)]="itemProduto.valorCompra"
                                        mode="currency"
                                        inputId="currency-brazil"
                                        currency="BRL"
                                        locale="pt-BR"
                                        [allowEmpty]="false"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="lucro">Lucro</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="lucro"
                                        ngModel
                                        #lucro="ngModel"
                                        [max]="100"
                                        [(ngModel)]="itemProduto.lucro"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                    ></p-inputNumber>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="valorVenda">Valor Venda</label>
                                    <div class="flex flex-row">
                                        <p-inputNumber
                                            name="valorVenda"
                                            ngModel
                                            #valorVenda="ngModel"
                                            [(ngModel)]="itemProduto.valorVenda"
                                            mode="currency"
                                            inputId="currency-brazil"
                                            currency="BRL"
                                            locale="pt-BR"
                                            [allowEmpty]="false"
                                        ></p-inputNumber>
                                        <button
                                            pButton
                                            pRipple
                                            pTooltip="Calcular precificação"
                                            (click)="abrirDialogValorSugerido()"
                                            type="button"
                                            icon="pi pi-percentage"
                                            class="p-button-success w-4rem ml-1"
                                        ></button>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="comissaoVenda">Comissão de Venda</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="comissaoVenda"
                                        ngModel
                                        #comissaoVenda="ngModel"
                                        [max]="100"
                                        [(ngModel)]="itemProduto.comissaoVenda"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label htmlFor="codigo">Código</label>
                                    <input
                                        type="text"
                                        pInputText
                                        name="codigo"
                                        oninput="this.value = this.value.toUpperCase();"
                                        [(ngModel)]="itemProduto.codigo"
                                        ngModel
                                        #codigo="ngModel"
                                        (blur)="verificarCodigoExistente(codigo.value)"
                                    />
                                    <div
                                        *ngIf="codigo.hasError('required') && codigo.touched"
                                        class="alerta"
                                    >
                                        <span>Campo obrigatório!</span>
                                    </div>
                                    <div
                                        *ngIf="!codigo.hasError('required') && codigoExistente"
                                        class="alerta"
                                    >
                                        <span>Código já cadastrado!</span>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-1" *ngIf="!temEstoque">
                                    <label for="controlaEstoque">Controla Estoque</label>
                                    <br />
                                    <p-inputSwitch
                                        name="controlaEstoque"
                                        ngModel
                                        #controlaEstoque="ngModel"
                                        [(ngModel)]="itemProduto.controlaEstoque"
                                    ></p-inputSwitch>
                                </div>
                                <div class="form-group field col-12 md:col-2" *ngIf="temEstoque">
                                    <label>Controla Estoque</label>
                                    <div class="form-control">
                                        <label
                                            class="product-badge status-instock"
                                            id="controlaEstoque"
                                            *ngIf="itemProduto.controlaEstoque"
                                        >
                                            SIM
                                        </label>
                                        <label
                                            class="product-badge status-outofstock"
                                            id="controlaEstoque"
                                            *ngIf="!itemProduto.controlaEstoque"
                                        >
                                            NÃO
                                        </label>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="estoqueMinimo">Estoque Mínimo</label>
                                    <p-inputNumber
                                        name="estoqueMinimo"
                                        ngModel
                                        #estoqueMinimo="ngModel"
                                        [(ngModel)]="itemProduto.estoqueMinimo"
                                        mode="decimal"
                                        [allowEmpty]="false"
                                        [useGrouping]="false"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="estoqueMaximo">Estoque Máximo</label>
                                    <p-inputNumber
                                        name="estoqueMaximo"
                                        ngModel
                                        #estoqueMaximo="ngModel"
                                        [(ngModel)]="itemProduto.estoqueMaximo"
                                        mode="decimal"
                                        [allowEmpty]="false"
                                        [useGrouping]="false"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-2" *ngIf="!temEstoque">
                                    <label htmlFor="quantidadeUnidadeMedida">
                                        Qtd. UN de Medida
                                    </label>
                                    <p-inputNumber
                                        name="quantidadeUnidadeMedida"
                                        ngModel
                                        #quantidadeUnidadeMedida="ngModel"
                                        [(ngModel)]="itemProduto.quantidadeUnidadeMedida"
                                        mode="decimal"
                                        [allowEmpty]="false"
                                        [useGrouping]="false"
                                    ></p-inputNumber>
                                </div>
                                <div class="form-group field col-12 md:col-2" *ngIf="temEstoque">
                                    <label>Qtd. UN de Medida</label>
                                    <label class="form-control" id="qtdUnidadeMedida">
                                        {{ itemProduto.quantidadeUnidadeMedida }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-2" *ngIf="!temEstoque">
                                    <label htmlFor="descricaoUnidadeMedida">
                                        Desc. UN de Medida
                                    </label>
                                    <p-dropdown
                                        [options]="unidadesMedidas"
                                        [filter]="true"
                                        optionLabel="label"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="descricaoUnidadeMedida"
                                        [(ngModel)]="itemProduto.descricaoUnidadeMedida"
                                        ngModel
                                        #descricaoUnidadeMedida="ngModel"
                                    ></p-dropdown>
                                </div>
                                <div class="form-group field col-12 md:col-2" *ngIf="temEstoque">
                                    <label>Desc. UN de Medida</label>
                                    <label class="form-control" id="descricaoUnidadeMedida">
                                        {{ itemProduto.descricaoUnidadeMedida }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-1">
                                    <label for="tributacao">Tributável?</label>
                                    <br />
                                    <p-inputSwitch
                                        name="tributacao"
                                        ngModel
                                        #tributacao="ngModel"
                                        [(ngModel)]="itemProduto.tributacao"
                                    ></p-inputSwitch>
                                </div>
                                <div class="field col-12 md:col-1">
                                    <label for="ativo">Ativo?</label>
                                    <br />
                                    <p-inputSwitch
                                        name="ativo"
                                        ngModel
                                        #ativo="ngModel"
                                        [(ngModel)]="itemProduto.ativo"
                                    ></p-inputSwitch>
                                </div>
                            </div>
                        </p-tabPanel>
                        <p-tabPanel header="tributacao">
                            <ng-template pTemplate="header">
                                <i class="pi pi-user mr-1"></i>
                                <span>Tributação</span>
                            </ng-template>
                            <div
                                class="flex justify-content-center"
                                *ngIf="exibirSpinnerTributacao"
                            >
                                <p-progressSpinner></p-progressSpinner>
                            </div>
                            <div class="p-fluid p-formgrid grid" *ngIf="!exibirSpinnerTributacao">
                                <div class="field col-12 md:col-12"></div>
                                <div class="field col-12 md:col-6">
                                    <label htmlFor="gtin">GTIN (cEAN)</label>
                                    <input
                                        type="text"
                                        pInputText
                                        name="gtin"
                                        oninput="this.value = this.value.toUpperCase();"
                                        ngModel
                                        #gtin="ngModel"
                                        [(ngModel)]="itemProduto.gtin"
                                    />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="aliquotaIcms">Alíquota ICMS</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="aliquotaIcms"
                                        ngModel
                                        #aliquotaIcms="ngModel"
                                        [max]="100"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                        [(ngModel)]="itemProduto.aliquotaIcms"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="aliquotaIcmsEntrada">Alíq. ICMS Entrada</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="aliquotaIcmsEntrada"
                                        ngModel
                                        #aliquotaIcmsEntrada="ngModel"
                                        [max]="100"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                        [(ngModel)]="itemProduto.aliquotaIcmsEntrada"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="fcp" pTooltip="Fundo de Combate a Pobreza">
                                        FCP
                                    </label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="fcp"
                                        ngModel
                                        #fcp="ngModel"
                                        [max]="100"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                        [(ngModel)]="itemProduto.fcp"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-6">
                                    <label htmlFor="cstOrigem">CST Origem da Mercadoria</label>
                                    <p-dropdown
                                        [options]="danfeCstOrigem"
                                        [filter]="true"
                                        optionLabel="label"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cstOrigem"
                                        ngModel
                                        #cstOrigem="ngModel"
                                        [(ngModel)]="itemProduto.cstOrigem"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-6">
                                    <label htmlFor="cstTributIcms">CST Tributação pelo ICMS</label>
                                    <p-dropdown
                                        [options]="danfeCstEmpresa"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cstTributIcms"
                                        ngModel
                                        #cstTributIcms="ngModel"
                                        [(ngModel)]="itemProduto.cstTributIcms"
                                        (onChange)="recarregarCfop('CST')"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-6">
                                    <label htmlFor="csosn">CSOSN</label>
                                    <p-dropdown
                                        [options]="danfeCsosn"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="csosn"
                                        ngModel
                                        #csosn="ngModel"
                                        [(ngModel)]="itemProduto.csosn"
                                        (onChange)="recarregarCfop('CSOSN')"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-6">
                                    <label htmlFor="cfop">CFOP</label>
                                    <p-dropdown
                                        [options]="danfeCfop"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cfop"
                                        ngModel
                                        #cfop="ngModel"
                                        [(ngModel)]="itemProduto.cfop"
                                        [required]="true"
                                    ></p-dropdown>
                                </div>

                                <div class="field col-12 md:col-10">
                                    <label htmlFor="cstPis">CST PIS</label>
                                    <p-dropdown
                                        [options]="danfeCstPis"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cstPis"
                                        ngModel
                                        #cstPis="ngModel"
                                        [(ngModel)]="itemProduto.cstPis"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="aliquotaPis">Alíquota PIS</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="aliquotaPis"
                                        ngModel
                                        #aliquotaPis="ngModel"
                                        [max]="100"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                        [(ngModel)]="itemProduto.aliquotaPis"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-10">
                                    <label htmlFor="cstCofins">CST COFINS</label>
                                    <p-dropdown
                                        [options]="danfeCstPis"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cstCofins"
                                        ngModel
                                        #cstCofins="ngModel"
                                        [(ngModel)]="itemProduto.cstCofins"
                                    ></p-dropdown>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="aliquotaCofins">Alíquota COFINS</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="aliquotaCofins"
                                        ngModel
                                        #aliquotaCofins="ngModel"
                                        [max]="100"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                        [(ngModel)]="itemProduto.aliquotaCofins"
                                    ></p-inputNumber>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="cest">CEST</label>
                                    <input
                                        type="text"
                                        pInputText
                                        name="cest"
                                        oninput="this.value = this.value.toUpperCase();"
                                        ngModel
                                        #cest="ngModel"
                                        [(ngModel)]="itemProduto.cest"
                                        minlength="7"
                                        maxlength="7"
                                    />
                                    <div class="alerta" *ngIf="cest.invalid">
                                        CEST deve ter 7 caracteres
                                    </div>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="ncm">NCM</label>
                                    <input
                                        type="text"
                                        pInputText
                                        name="ncm"
                                        oninput="this.value = this.value.toUpperCase();"
                                        ngModel
                                        #ncm="ngModel"
                                        [(ngModel)]="itemProduto.ncm"
                                        minlength="8"
                                        maxlength="10"
                                    />
                                    <div class="alerta" *ngIf="ncm.invalid">
                                        NCM deve ter 8 a 10 caracteres
                                    </div>
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label for="indEscala">Indicador de Escala Relevante?</label>
                                    <p-dropdown
                                        [options]="listaIndEscala"
                                        optionLabel="label"
                                        [filter]="true"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="indEscala"
                                        ngModel
                                        #indEscala="ngModel"
                                        [(ngModel)]="itemProduto.indEscala"
                                    ></p-dropdown>
                                </div>
                                <div
                                    class="field col-12 md:col-3"
                                    *ngIf="itemProduto.indEscala == 'N' && itemProduto.fabricante"
                                >
                                    <label htmlFor="cnpjFabricante">CNPJ Fabricante</label>
                                    <p-inputMask
                                        type="text"
                                        mask="99.999.999/9999-99"
                                        [unmask]="true"
                                        placeholder="000.000.000-00"
                                        name="cnpjFabricante"
                                        ngModel
                                        #cnpjFabricante="ngModel"
                                        [(ngModel)]="itemProduto.fabricante.cnpj"
                                        (onBlur)="buscarCnpjFabricante()"
                                        [disabled]="desabilitarCnpj"
                                    ></p-inputMask>
                                    <div class="alerta" *ngIf="semCnpj">
                                        é preciso cadastrar o CNPJ
                                    </div>
                                    <div class="alerta" *ngIf="cnpjExiste">CNPJ já existe!</div>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label>CST-IBS/CBS</label>
                                    <p-dropdown
                                        [options]="listaCstIbsCbs"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cstIbsCbs"
                                        #cstIbsCbs="ngModel"
                                        [(ngModel)]="itemProduto.cstIbsCbs"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label>Classificação Tributária</label>
                                    <p-dropdown
                                        [options]="listaClassTrib"
                                        emptyFilterMessage="Nenhum registro"
                                        placeholder="Selecione"
                                        name="cClassTrib"
                                        #cClassTrib="ngModel"
                                        [(ngModel)]="itemProduto.classTrib"
                                    ></p-dropdown>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label>Alíquota IS</label>
                                    <p-inputNumber
                                        suffix="%"
                                        name="aliqIsProduto"
                                        #aliqIsProduto="ngModel"
                                        [max]="100"
                                        [minFractionDigits]="2"
                                        [maxFractionDigits]="2"
                                        [allowEmpty]="false"
                                        [(ngModel)]="itemProduto.aliqIsProduto"
                                    ></p-inputNumber>
                                </div>
                            </div>
                        </p-tabPanel>
                        <p-tabPanel header="detalhes">
                            <ng-template pTemplate="header">
                                <i class="pi pi-book mr-1"></i>
                                <span>Mais Detalhes</span>
                            </ng-template>
                            <div class="p-fluid p-formgrid grid justify-content-between">
                                <div class="field col-12 md:col-8">
                                    <label>URL Produto</label>
                                    <input
                                        type="text"
                                        pInputText
                                        name="urlProduto"
                                        ngModel
                                        #urlProduto="ngModel"
                                        [(ngModel)]="itemProduto.urlDetalheProduto"
                                    />
                                </div>
                                <div
                                    class="col-12 md:col-3 text-center pt-5"
                                    *ngIf="itemProduto.urlDetalheProduto"
                                >
                                    <qrcode
                                        class="cursor-pointer"
                                        pTooltip="Ver dados"
                                        [qrdata]="itemProduto.urlDetalheProduto"
                                        [width]="180"
                                        [errorCorrectionLevel]="'M'"
                                        (click)="abrirUrlProduto()"
                                        imageSrc="../assets/images/logo_qrcode.png"
                                    ></qrcode>
                                </div>
                            </div>
                        </p-tabPanel>
                    </p-tabView>
                    <div
                        class="p-fluid p-formgrid grid justify-content-between"
                        *ngIf="!exibirSpinnerTributacao"
                    >
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                class="p-button-outlined sm:w-9rem p-button-success"
                                (click)="atualizar()"
                                [disabled]="!form.valid || codigoExistente"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="submit"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Atualizar"
                                    class="p-button-outlined sm:w-9rem p-button-success"
                                    [disabled]="true"
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined sm:w-9rem"
                                routerLink="/apps/item-produto"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog
                [(visible)]="exibirDialogValorSugerido"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [style]="{ width: '35vw' }"
                [header]="'Sugestão de preço - ' + itemProduto?.descricao"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                class="p-fluid"
            >
                <ng-template pTemplate="content">
                    <div class="flex justify-content-center" *ngIf="loadingSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="formgrid grid" *ngIf="!loadingSpinnerDialog && itemProduto">
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Valor Compra</label>
                            <label class="block">
                                {{ itemProduto.valorCompra | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Frete</label>
                            <label class="block">
                                {{ percentualFrete / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Lucro</label>
                            <label class="block">
                                {{ (itemProduto.lucro ?? 0) / 100 | percent: "1.2-2" }} |
                                {{
                                    ((itemProduto.lucro ?? 0) *
                                        ((itemProduto.valorCompra ?? 0) /
                                            (itemProduto.quantidadeUnidadeMedida ?? 1))) /
                                        100 | currency: "BRL"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Comissão</label>
                            <label class="block">
                                {{
                                    itemProduto.comissaoVenda
                                        ? (itemProduto.comissaoVenda / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Custo Fixo</label>
                            <label class="block">
                                {{ custoMedio.custoFixo / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Custo Tributário</label>
                            <label class="block">
                                {{ custoMedio.imposto / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Valor Venda</label>
                            <label class="block">
                                {{ itemProduto.valorVenda | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Lucro Atual</label>
                            <label class="block">
                                {{ valorLucroObtidoAtual | currency: "BRL" }} |
                                {{
                                    valorLucroObtidoAtual / (this.itemProduto.valorVenda ?? 0)
                                        | percent: "1.2-2"
                                }}
                            </label>
                        </div>
                        <div style="width: 100%">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 sm:col-4">
                            <label class="font-semibold text-lg">Valor Sugerido</label>
                            <label class="block">
                                {{ valorSugerido | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-4">
                            <label class="font-semibold text-lg">Novo Valor</label>
                            <p-inputNumber
                                name="novoValor"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                (onInput)="calcularLucroObtido($event.value)"
                                [(ngModel)]="novoValor"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 sm:col-4">
                            <label class="font-semibold text-lg">Lucro Obtido</label>
                            <label class="block">
                                <span
                                    class="product-badge bg-green-600 admihair-text-white"
                                    *ngIf="valorLucroObtido >= 0"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                                <span
                                    class="product-badge bg-red-600 admihair-text-white"
                                    *ngIf="valorLucroObtido < 0"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                            </label>
                        </div>
                        <!-- <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Lucro Desejado</label>
                            <p-inputNumber
                                name="valorLucroDesejado"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="valorLucroDesejado"
                                (ngModelChange)="calcularValorSugerido()"
                            ></p-inputNumber>
                        </div> -->
                    </div>
                    <div class="flex justify-content-start mt-3" *ngIf="!loadingSpinnerDialog">
                        <button
                            type="button"
                            pButton
                            pRipple
                            label="Confirmar"
                            icon="pi pi-check"
                            class="p-button-outlined w-full md:w-12rem"
                            [disabled]="novoValor <= 0"
                            (click)="confirmarNovoValor()"
                        ></button>
                    </div>
                </ng-template>
            </p-dialog>
            <p-dialog
                header="Sucesso"
                [(visible)]="modalFabricante"
                [style]="{ width: '40vw' }"
                [baseZIndex]="10000"
                [resizable]="false"
                [modal]="true"
                [draggable]="false"
            >
                <p>O CNPJ do Fabricante Informado foi cadastrado!</p>
                <ng-template pTemplate="footer">
                    <p-button
                        icon="pi pi-check"
                        (click)="modalFabricante = false"
                        label="OK"
                        styleClass="p-button-primary"
                    ></p-button>
                </ng-template>
            </p-dialog>
        </div>
    </div>
</div>
